import { ApolloLink } from '@apollo/client';
import { getJwtToken } from './preferencesClient';

export const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: getJwtToken() || '',
    },
  }));
  return forward(operation);
});
